module.exports = __webpack_public_path__ + "static/media/logo.738ad7a5.png";